import produce from 'immer';
import { atom } from 'recoil';
import reducerSelector from '../utils/reducerSelector';

export const LOADING_LIST_CLIENT = 'LOADING_LIST_CLIENT';
export const LOADED_LIST_CLIENT = 'LOADED_LIST_CLIENT';
export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS';
export const REMOVE_SEARCH = 'REMOVE_SEARCH';

export const clientAtom = atom({
  key: 'clientState',
  default: {
    page: 0,
    size: 20,
    items: [],
    order_by: 'id',
    desc: true,
    total: 0,
    isListing: false,
    q: '',
    telephone: [],
  },
});
export const clientReducer = (state, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LOADING_LIST_CLIENT: {
        draft.isListing = true;
        break;
      }
      case LOADED_LIST_CLIENT: {
        draft.isListing = false;
        Object.entries(action.data).forEach(([k, v]) => {
          draft[k] = v;
        });
        Object.entries(action.params).forEach(([k, v]) => {
          draft[k] = v;
        });
        break;
      }
      case ADD_CLIENT_SUCCESS: {
        draft.items = [action.data, ...state.items];
        draft.total += 1;
        break;
      }
      case REMOVE_SEARCH: {
        draft.q = '';
        break;
      }
      default:
        throw new Error();
    }
  });
export const clientSelector = reducerSelector({
  selectorKey: 'clientSelector',
  reducer: clientReducer,
  selectorAtom: clientAtom,
});
